import React from "react";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;